<div class="h-100" [ngClass]="{'position-relative overflow-hidden': settingsLoading}">
    <cv-loader *ngIf="settingsLoading" class="d-block" [overlay]="true" [size]="'medium'"></cv-loader>

    <!-- Module content will be compiled here -->
    <ng-template #dynamicSettings></ng-template>
    <cv-module-legacy-settings-modal [hidden]="settingsLoading"
                                     [embedMode]="true"
                                     [moduleManager]="moduleManager"
                                     [module]="module"
                                     [moduleInfo]="moduleInfo"
                                     [triggerApply]="triggerApplySettings"
                                     (settingsApplied)="applySettings()"
                                     (settingsFailed)="settingsFailed.emit()"
                                     (settingsViewChanged)="settingsViewChanged($event)">
    </cv-module-legacy-settings-modal>
    <!-- Container for the Metric Selector to be added-->
    <div class="subscriptionModule"></div>
</div>
